module.exports = __webpack_public_path__ + "static/media/sol.a3266071.svg";